import realDate from './real-date';

export const now = () => {
  return realDate(new Date());
};
